import Rule from "../../../common/rule";
import { isSeriesOvertime } from "../../utils/overtime-utils";

/**
 * OT Kickoffs (PSTATS-1268): the toss is followed by a kickoff, as at the
 * start of a game. A child of CoinToss; its own child, StartKickOff, arms the
 * kick at the Kickoff Yardline.
 *
 * The toss names the team that starts on offense, which here is the
 * receiving team, so its opponent holds the ball for the kick. The fragment
 * keeps that meaning in both overtime formats, and with it the legacy
 * comment "X won toss. Y starts offensive."
 *
 * It closes no drive. The drive regulation left running is closed when OT1
 * starts (FootballService._createOvertimeCoinTossPlay), before the toss
 * exists. Closing it here as well reached only replays: after Support >
 * Rebuild Drive Times the toss's snapshot still names that drive, and
 * reprocessing the toss (insertion after it, for one) then closed the live
 * overtime drive instead, since DriveService.endDrive closes the earliest
 * incomplete drive.
 */
export default class OvertimeOpensWithKickoff extends Rule {
    applicable(gameContext) {
        return (
            gameContext.getOvertimePeriod() >= 1 &&
            !isSeriesOvertime(gameContext)
        );
    }

    // eslint-disable-next-line no-unused-vars
    async apply(gameContext, ruleContext, eventConfiguration, { fragment }) {
        const receivingTeamId = fragment.settings.offenseTeam.id;
        gameContext.setPossessionForTeamId(
            gameContext.getOpponent(receivingTeamId)
        );
        gameContext.setDriveContext({ triggerDrive: false });
    }
}
